module.exports = "<ng-container *ngIf=\"content | async as page\">\n    <ng-container *ngIf=\"page | meta\">\n        <marquee-row [item]=\"page | meta\"></marquee-row>\n        <detail-row [item]=\"page | meta\" [truncateText]=\"false\"></detail-row>\n        <ng-container *ngIf=\"(page | meta).content\">\n            <content-builder class=\"quote-block\" [items]=\"(page | meta).content\"></content-builder>\n        </ng-container>\n    </ng-container>\n    <rows [rows$]=\"page.rows\"></rows>\n</ng-container>"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/containers/page-container/page-container.component.html
// module id = 856
// module chunks = 2